import { render } from "./enforce-sso-access-confirm-modal.vue?vue&type=template&id=a5a52ad4"
import script from "./enforce-sso-access-confirm-modal.vue?vue&type=script&lang=js"
export * from "./enforce-sso-access-confirm-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__